import { lazy } from 'react'
import { Switch, Route } from 'react-router-dom'

const Home = lazy(() => import(/* webpackChunkName: "Home" */ '@/pages/Home'))
const Detail = lazy(() => import(/* webpackChunkName: "Detail" */ '@/pages/Detail'))
const Confirm = lazy(() => import(/* webpackChunkName: "Confirm" */ '@/pages/Confirm'))
const Result = lazy(() => import(/* webpackChunkName: "Result" */ '@/pages/Result'))
const Rules = lazy(() => import(/* webpackChunkName: "Rules" */ '@/pages/Rules'))
const RuleDescription = lazy(() =>
  import(/* webpackChunkName: "Rules" */ '@/pages/RuleDescription'),
)
const CopperRecord = lazy(() =>
  import(/* webpackChunkName: "CopperRecord" */ '@/pages/CopperRecord'),
)

const AwardRecord = lazy(() => import(/* webpackChunkName: "AwardRecord" */ '@/pages/AwardRecord'))
const ReplaceUrl = lazy(() => import(/* webpackChunName: "RepalceUrl" */ '@/pages/ReplaceUrl'))

// import Home from '@/pages/Home'
// import Detail from '@/pages/Detail'
// import Confirm from '@/pages/Confirm'
// import Result from '@/pages/Result'
// import Rules from '@/pages/Rules'
// import CopperRecord from '@/pages/CopperRecord'
const ROUTES_ARR = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/detail/:id',
    component: Detail,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/confirm/:id',
    component: Confirm,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/award-record',
    component: AwardRecord,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/result/:type',
    component: Result,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/rules',
    component: Rules,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/rule-des',
    component: RuleDescription,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/copper-record',
    component: CopperRecord,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/link-to-duiba',
    component: ReplaceUrl,
  },
]

// const DEFAULT_SCENE_CONFIG = {
//   enter: 'from-right',
//   exit: 'to-right',
// }

/**
 *
 * @param {any} location
 * @returns
 */
// const getSceneConfig = location => {
//   const matchedRoute = ROUTES_ARR.find(config => {
//     return new RegExp(`^${config.path}$`).test(location.pathname)
//   })

//   // @ts-ignore
//   return (matchedRoute && matchedRoute.sceneConfig) || DEFAULT_SCENE_CONFIG
// }

/**
 * @type {object}
 */
// let oldLocation = null

const RouteConfig = () => {
  return (
    <Switch>
      {ROUTES_ARR.map((config, index) => (
        // @ts-ignore
        <Route exact key={index} {...config} />
      ))}
    </Switch>
  )
}

export { RouteConfig }
